import { LoadingSpinner } from "MVVM/Components/Lottie";
import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

const NoResults = ({ loading }: { loading: boolean }) => (
  <NoResultsContainer>
    {loading ? (
      <Flex mt={20} alignItems="center" data-testid="loading-indicator">
        <LoadingSpinner height={24} width={24} />
      </Flex>
    ) : (
      <>
        <Text
          color="chalkAlpha40"
          fontSize={18}
          fontWeight={500}
          mt={[60, 60, 20]}
        >
          No Results Found
        </Text>
        <Text color="chalkAlpha40" fontSize={12} fontWeight={500}>
          Try searching for a different username
        </Text>
      </>
    )}
  </NoResultsContainer>
);

const NoResultsContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 30px;
`;

export { NoResults };
